import { render, staticRenderFns } from "./QuickAdd.vue?vue&type=template&id=0f5c41a8&scoped=true"
import script from "./QuickAdd.vue?vue&type=script&lang=js"
export * from "./QuickAdd.vue?vue&type=script&lang=js"
import style0 from "./QuickAdd.vue?vue&type=style&index=0&id=0f5c41a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5c41a8",
  null
  
)

export default component.exports